<img [src]="logo$ | async">